import {AiChatSize} from '@AiChat/hooks/useAiChatSize.types';

export enum ImageActionId {
  CHANGE_STYLE = 'change_style',
  TURN_INTO_VIDEO = 'turn_into_video',
  DOWNLOAD = 'download',
  SHARE_DESIGN = 'share_design',
  SAVE_TO_MY_DESIGNS = 'save_to_my_designs',
  OPEN_IN_EDITOR = 'open_in_editor',
  MAKE_TEXT_EDITABLE = 'make_text_editable',
  PUBLISH_TO_SOCIAL_MEDIA = 'publish_to_social_media',
  PUBLISH_AS_EMAIL_CAMPAIGN = 'publish_as_email_campaign',
  PROMOTE_AS_EVENT = 'promote_as_event',
}

export interface ImageActionAvailabilityContext {
  isLastMessage: boolean;
  canWrite: boolean;
  hasLayeredPoster: boolean;
  isEventsCalendarPromotionChat: boolean;
  isCreateAVideoFeatureEnabled: boolean;
  canUseEditableTextLayers: boolean;
  isPrimaryPublishingOptionPromoted: boolean;
  hasImage: boolean;
}

export interface ImageActionDescriptor {
  id: ImageActionId;
  icon: string;
  labelKey: string;
  minimumInlineSize: AiChatSize | null;
  isAvailable: (context: ImageActionAvailabilityContext) => boolean;
  isInlineEligible: (context: ImageActionAvailabilityContext) => boolean;
  isPinnedInline?: boolean;
}

export interface ResolvedImageActions {
  inline: ImageActionDescriptor[];
  overflow: ImageActionDescriptor[];
}

export interface ResolveImageActionsParams {
  size: AiChatSize;
  context: ImageActionAvailabilityContext;
}

export const INLINE_SLOT_BUDGET: Record<AiChatSize, number> = {
  [AiChatSize.SMALL]: 1,
  [AiChatSize.MEDIUM]: 3,
  [AiChatSize.LARGE]: 5,
};

export const INLINE_SKELETON_WIDTH = 120;

export const OVERFLOW_SKELETON_WIDTH = 32;

export const IMAGE_ACTION_SKELETON_HEIGHT = 32;
